import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, X, MessageCircle, FileQuestion, Mail } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const HelpWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  const quickLinks = [
    { icon: FileQuestion, label: 'FAQ & Troubleshooting', href: '/faq#troubleshooting', external: false },
    { icon: MessageCircle, label: 'How Matching Works', href: '/faq#getting-started', external: false },
    { icon: Mail, label: 'Contact Support', href: 'mailto:support@matchitup.in', external: true },
  ];

  return (
    <div className="fixed bottom-20 sm:bottom-20 right-4 sm:right-6 z-50 hidden sm:block" data-testid="help-widget">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            className="absolute bottom-16 right-0 w-64 bg-white rounded-xl shadow-2xl border border-slate-200 overflow-hidden"
          >
            <div className="px-4 py-3" style={{ background: '#E8430A' }}>
              <h3 className="text-white font-semibold text-sm">Need Help?</h3>
              <p className="text-white/70 text-xs">Quick answers & support</p>
            </div>
            <div className="p-2">
              {quickLinks.map((link, idx) => (
                link.external ? (
                  <a
                    key={idx}
                    href={link.href}
                    className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-slate-50 transition-colors"
                    onClick={() => setIsOpen(false)}
                  >
                    <link.icon className="w-4 h-4 text-[#E8430A]" />
                    <span className="text-sm text-slate-700">{link.label}</span>
                  </a>
                ) : (
                  <Link
                    key={idx}
                    to={link.href}
                    className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-slate-50 transition-colors"
                    onClick={() => setIsOpen(false)}
                  >
                    <link.icon className="w-4 h-4 text-[#E8430A]" />
                    <span className="text-sm text-slate-700">{link.label}</span>
                  </Link>
                )
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-all ${
          isOpen 
            ? 'bg-slate-700 hover:bg-slate-800' 
            : 'hover:opacity-85'
        }`}
        style={isOpen ? {} : { background: '#E8430A' }}
        data-testid="help-widget-toggle"
      >
        {isOpen ? (
          <X className="w-5 h-5 text-white" />
        ) : (
          <HelpCircle className="w-5 h-5 text-white" />
        )}
      </button>
    </div>
  );
};

export default HelpWidget;
